enum CardIssuer {
  STRIPE = "STRIPE",
  HIGHNOTE = "HIGHNOTE",
}

export default CardIssuer;
